"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Lumen = void 0;
var uom_1 = require("uom");
var UnitTimes = require("../unit-times");
var solid_angle_1 = require("./solid-angle");
/**
 * The derived unit for luminous flux ( <code>lm</code> ).
 * One Lumen is equal to the amount of light given out through a solid angle by a source of one
 * candela intensity radiating equally in all directions.
 */
exports.Lumen = UnitTimes.luminousIntensityBySolidAngle("Lumen", uom_1.BaseUnits.Candela, solid_angle_1.Steradian);
//# sourceMappingURL=luminous-flux.js.map